import { render, staticRenderFns } from "./ProductCost5.vue?vue&type=template&id=4fafc459&scoped=true&"
import script from "./ProductCost5.vue?vue&type=script&lang=js&"
export * from "./ProductCost5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fafc459",
  null
  
)

export default component.exports